const notificationClient = require("./packages/notification-client");
const providerClient = require("./packages/provider-client");
const javelinaClient = require("./packages/javelina-client");
const claimActivityClient = require("./packages/claim-activity-client");
const claimAccumulatorClient = require("./packages/claim-accumulator-client");
const planManagerClient = require("./packages/plan-manager-client");
const referralServiceClient = require("./packages/referral-client");
const memberClient = require("./packages/member-client");
const elationClient = require("./packages/elation-client");
const locationClient = require("./packages/location-client");
const idpClient = require("./packages/idp-client");
module.exports = {
  ...javelinaClient,
  ...notificationClient,
  ...providerClient,
  ...planManagerClient,
  ...claimActivityClient,
  ...claimAccumulatorClient,
  ...referralServiceClient,
  ...memberClient,
  elationClient,
  ...locationClient,
  ...idpClient,
};
